import { initializeApp } from "@firebase/app";
import { signOut as fbSignOut, getAuth, signInWithCustomToken } from "@firebase/auth";

export default initializeApp(
  import.meta.env.SIPPY_ENV === "production"
    ? {
        apiKey: "AIzaSyBiEfFzZ9tOuhxfqkNV0BRGYSMO0nalk-E",
        authDomain: "oceanic-gecko-192414.firebaseapp.com",
        projectId: "oceanic-gecko-192414",
        storageBucket: "optimisevoip-audio",
        messagingSenderId: "1087210276662",
      }
    : {
        apiKey: "AIzaSyBP6oeDeEWOFloBrIPozXmOXwJZzAhWEb8",
        authDomain: "sippy-platform-staging.firebaseapp.com",
        projectId: "sippy-platform-staging",
        storageBucket: "sippy-platform-staging-audio",
        messagingSenderId: "903795048696",
      },
);

// Authenticate the user with the PBX context
export const auth = getAuth();

export const authenticate = (token) => {
  signInWithCustomToken(auth, token).catch((error) => error);
};

export const signOut = () => {
  fbSignOut(auth).catch((error) => error);
};
